import * as React from 'react'
import { AccountDto } from '@halo/dtos/account.dto'
import { Drawer, executeCleanDrawerRender, Well } from '@pushly/aqe/lib/components'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import { notification, Skeleton } from 'antd'
import { classnames } from '@halo/_utils/classnames'
import CopyToClipboard from 'react-copy-to-clipboard'
import { simpleFormErrorNotification, simpleNotification } from '@halo/_utils/notifications'
import { FormComponentProps } from '@ant-design/compatible/lib/form'
import { AppState } from '@halo/stores/app.state'
import { AppService } from '@halo/services/app.service'
import { AccountService } from '@halo/services/account.service'
import { Container } from 'typescript-ioc/es5'
import { DEFAULT_DRAWER_FORM_ITEM_LAYOUT } from '@halo/constants'
import { legacyValidateFields } from '@halo/_utils/antd'
import * as randomstring from 'randomstring'

interface IAccountIntegrationsEditor extends FormComponentProps {
    account: AccountDto
    visible: boolean
    onClose: (e: any) => void
    onAccountUpdated: (account: Partial<AccountDto>) => void
}

interface IAIEState {
    credentialUpload?: any
}

export const AccountIntegrationsEditor = Form.create<IAccountIntegrationsEditor>()(
    class extends React.Component<IAccountIntegrationsEditor, IAIEState> {
        public state: IAIEState = {}

        protected appState: AppState
        protected appService: AppService
        protected accountService: AccountService

        public constructor(props: IAccountIntegrationsEditor) {
            super(props)

            this.appState = Container.get(AppState)
            this.appService = Container.get(AppService)
            this.accountService = Container.get(AccountService)

            executeCleanDrawerRender(this)
        }

        public render() {
            const currentValues = this.getCurrentValues()

            return (
                <Drawer
                    className={classnames('adf-integrations-editor')}
                    title="Update Integrations"
                    placement="right"
                    closable={true}
                    onSubmit={this.handleSubmit}
                    disableSubmit={Object.keys(currentValues).length === 0}
                    onClose={this.props.onClose}
                    visible={this.props.visible}
                >
                    <Form {...DEFAULT_DRAWER_FORM_ITEM_LAYOUT}>
                        <Well title="Default Send Configuration" mode="ghost" hideFooter={true}></Well>
                    </Form>
                </Drawer>
            )
        }

        protected get account(): AccountDto {
            return this.props.account
        }

        protected getCurrentValues(): Partial<AccountDto> {
            let values: Partial<AccountDto> = {}

            return values
        }

        protected handleSubmit = async () => {
            try {
                await legacyValidateFields(this.props.form)
                const mergedValues = this.getCurrentValues()

                let { ok, data } = await this.accountService.patch(this.account.id, mergedValues, true)

                if (ok) {
                    this.props.onAccountUpdated(data)
                    this.props.onClose(null)
                }
            } catch (err) {
                simpleFormErrorNotification(err)
            }
        }
    },
)

interface IAccountSendIntegrationsWell {
    loading?: boolean
    account: AccountDto
    title?: string
    onAccountUpdated: (account: Partial<AccountDto>) => void
}

interface IASIWState {
    showDrawer: boolean
    drawerKey?: string
}

export class AccountSendIntegrationsWell extends React.Component<IAccountSendIntegrationsWell, IASIWState> {
    public state: IASIWState = {
        showDrawer: false,
    }

    public render() {
        return (
            <Well className="type-3 nested" title="Send Integrations" hideFooter={true}>
                <Skeleton loading={this.props.loading} active={true} title={false}>
                    {!this.props.loading && (
                        <>
                            {this.renderVapidWell()}

                            {/*<AccountIntegrationsEditor*/}
                            {/*    key={this.state.drawerKey}*/}
                            {/*    visible={this.state.showDrawer}*/}
                            {/*    account={this.props.account}*/}
                            {/*    onClose={this.handleDrawerClose}*/}
                            {/*    onAccountUpdated={this.props.onAccountUpdated}*/}
                            {/*/>*/}
                        </>
                    )}
                </Skeleton>
            </Well>
        )
    }

    protected renderVapidWell() {
        return (
            <Well title="Vapid Configuration" mode="ghost" hideFooter={true}>
                <div className={classnames('form-layout-row')}>
                    <div className={classnames('form-layout-row-label')}>Public Key</div>
                    <div className={classnames('form-layout-row-value', 'can-copy')}>
                        <CopyToClipboard
                            onCopy={() => this.handleCopied('public vapid key')}
                            text={this.props.account.vapid_public_key}
                        >
                            <span>{this.props.account.vapid_public_key}</span>
                        </CopyToClipboard>
                    </div>
                </div>

                <div className={classnames('form-layout-row')}>
                    <div className={classnames('form-layout-row-label')}>Private Key</div>
                    <div className={classnames('form-layout-row-value', 'can-copy')}>
                        <CopyToClipboard
                            onCopy={() => this.handleCopied('private vapid key')}
                            text={this.props.account.vapid_private_key}
                        >
                            <span>{this.props.account.vapid_private_key}</span>
                        </CopyToClipboard>
                    </div>
                </div>
            </Well>
        )
    }

    protected handleDrawerOpen = async () => {
        return this.setState({ showDrawer: true, drawerKey: randomstring.generate() })
    }

    protected handleDrawerClose = async () => {
        return this.setState({ showDrawer: false })
    }

    protected handleCopied = (field: string) => {
        notification.destroy()
        simpleNotification('success', `Your ${field} has been copied!`)
    }
}
